// store/slices/ipSlice.js
import { createSlice } from '@reduxjs/toolkit';

const ipSlice = createSlice({
    name: 'ip',
    initialState: '', // <- just a string, not an object
    reducers: {
        setIP: (_, action) => action.payload,
    },
});

export const { setIP } = ipSlice.actions;
export const ipReducer = ipSlice.reducer;